var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from "react";
import styled from "styled-components";
import { bonfireGet } from "../../../theme/utils";
var PdfViewerWrapperStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  margin: 10px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  margin: 10px;\n"])), bonfireGet("colors", "background"));
var PdfVisualManipulator = function (props) {
    var children = props.children, id = props.id, className = props.className, style = props.style;
    return (React.createElement(PdfViewerWrapperStyle, { id: id, className: className, style: style }, children));
};
export default PdfVisualManipulator;
var templateObject_1;
//# sourceMappingURL=PdfVisualManipulator.js.map